/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const customerDeleteBodyExpectedCustomerVersionExclusiveMin = 0;
export const customerDeleteBodyExpectedCustomerVersionMax = 9007199254740991;

export const CustomerDeleteBody = zod.object({
  expectedCustomerVersion: zod
    .int()
    .gt(customerDeleteBodyExpectedCustomerVersionExclusiveMin)
    .max(customerDeleteBodyExpectedCustomerVersionMax),
  confirmed: zod.literal(true),
});

export type CustomerDeleteBody = zod.input<typeof CustomerDeleteBody>;
export type CustomerDeleteBodyOutput = zod.output<typeof CustomerDeleteBody>;
